function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import _Quill from 'quill';
var Quill = window.Quill || _Quill;
var Container = Quill.import('blots/container');
var Scroll = Quill.import('blots/scroll');
var ATTRIBUTES = ['data-embed-source', 'data-type', 'data-src', 'data-size', 'style'];
var Parchment = Quill.import('parchment');
var Embed = Quill.import('blots/block/embed');

var EmbedPlaceholder = /*#__PURE__*/function (_Embed) {
  _inherits(EmbedPlaceholder, _Embed);

  var _super = _createSuper(EmbedPlaceholder);

  function EmbedPlaceholder() {
    _classCallCheck(this, EmbedPlaceholder);

    return _super.apply(this, arguments);
  }

  _createClass(EmbedPlaceholder, [{
    key: "format",
    value: function format(name, value) {
      if (name === 'style') {
        this.domNode.style.cssText = value;
        return;
      }

      if (ATTRIBUTES.indexOf(name) === -1) {
        _get(_getPrototypeOf(EmbedPlaceholder.prototype), "format", this).call(this, name, value);

        return;
      }

      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    }
  }, {
    key: "handling",
    value: function handling(_handling) {
      this.domNode.__formats = this.constructor.formats(this.domNode);
      this.domNode.__handling = _handling;
    }
  }], [{
    key: "create",
    value: function create(value) {
      var node = _get(_getPrototypeOf(EmbedPlaceholder), "create", this).call(this);

      if (typeof value === 'string') {
        node.setAttribute(ATTRIBUTES[0], value);
      } else {
        for (var key in value) {
          if (!Object.prototype.hasOwnProperty.call(value, key)) continue;
          node.setAttribute(key, value[key]);
        }
      }

      node.setAttribute('contenteditable', false);
      node.setAttribute('unselectable', 'on'); // node.setAttribute('title', node.textContent);

      return node;
    }
  }, {
    key: "formats",
    value: function formats(domNode) {
      if (domNode.__handling && domNode.__formats) {
        return domNode.__formats;
      }

      var attrList = ATTRIBUTES.slice(3);
      return attrList.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }

        return formats;
      }, {});
    }
  }, {
    key: "value",
    value: function value(domNode) {
      var attrs = ATTRIBUTES.slice(0, 3);
      var result = {};
      attrs.forEach(function (attr) {
        var res = '';

        if (domNode.hasAttribute(attr)) {
          res = domNode.getAttribute(attr);
        } else {
          switch (attr) {
            case ATTRIBUTES[0]:
              res = encodeURIComponent(domNode.outerHTML);
              break;

            case ATTRIBUTES[1]:
              res = domNode.tagName;
              break;

            case ATTRIBUTES[2]:
              res = domNode.getAttribute('src');
              break;

            case 'style':
              res = domNode.style.cssText;
              break;

            default:
              res = domNode[attr] || '';
          }
        }

        if (res) result[attr] = res;
      });
      return result;
    }
  }]);

  return EmbedPlaceholder;
}(Embed);

EmbedPlaceholder.blotName = 'embed-placeholder';
EmbedPlaceholder.tagName = 'span';
EmbedPlaceholder.scope = Parchment.Scope.INLINE_BLOT;
Container.allowedChildren.push(EmbedPlaceholder);
Scroll.allowedChildren.push(EmbedPlaceholder);

var TagPlaceholder = /*#__PURE__*/function (_EmbedPlaceholder) {
  _inherits(TagPlaceholder, _EmbedPlaceholder);

  var _super2 = _createSuper(TagPlaceholder);

  function TagPlaceholder() {
    _classCallCheck(this, TagPlaceholder);

    return _super2.apply(this, arguments);
  }

  return TagPlaceholder;
}(EmbedPlaceholder);

TagPlaceholder.tagName = ['video', 'iframe'];

var ClassNamePlaceholder = /*#__PURE__*/function (_EmbedPlaceholder2) {
  _inherits(ClassNamePlaceholder, _EmbedPlaceholder2);

  var _super3 = _createSuper(ClassNamePlaceholder);

  function ClassNamePlaceholder() {
    _classCallCheck(this, ClassNamePlaceholder);

    return _super3.apply(this, arguments);
  }

  return ClassNamePlaceholder;
}(EmbedPlaceholder);

ClassNamePlaceholder.className = 'ql-embed-placeholder';
var tagReg = /<([\w-]+)((?:\s+[\w-:.]*(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*>([^<]*?)<\/\1>/g;
var attrReg = /([\w-:.]+)(?:\s*=\s*(?:"((?:\\.|[^"])*)"|'((?:\\.|[^'])*)'))?/g;

function convertPlaceholderHTML() {
  var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!html) return '';
  var matchReg = new RegExp("class\\s*=\\s*(?:\"[^\"]*\\b(".concat(ClassNamePlaceholder.className, ")\\b[^\"]*\"|'[^']*\\b(").concat(ClassNamePlaceholder.className, ")\\b[^']*')"));
  return html.replace(tagReg, function (m, tag) {
    var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    if (!tag || tag.toLowerCase() !== EmbedPlaceholder.tagName || !matchReg.test(attrs)) {
      return m;
    }

    var attributes = getAttributes(attrs);
    var source = decodeURIComponent(attributes[ATTRIBUTES[0]]); // if (!attributes.style) return source

    return replaceHTMLAttr(source, {
      style: attributes.style,
      'data-size': attributes['data-size']
    });
  });
}

function getAttributes(str) {
  var attributes = {};
  str.replace(attrReg, function (m, name, attr1, attr2) {
    var attr = (attr1 || attr2 || '').trim();
    attributes[name] = attr;
  });
  return attributes;
}

var sourceTagReg = /<([\w-]+)((?:\s+[\w-:.]*(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*>/;

function replaceHTMLAttr() {
  var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return html.replace(sourceTagReg, function (m, tag) {
    var attr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var attributes = getAttributes(attr);
    Object.assign(attributes, attrs);
    var attrsStr = Object.keys(attributes).reduce(function (str, key) {
      var val = attributes[key];
      if (val == null) return str;
      str += val === '' ? " ".concat(key) : " ".concat(key, "=\"").concat(val, "\"");
      return str;
    }, '');
    return "<".concat(tag).concat(attrsStr, ">");
  });
}

export default function register() {
  var formats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [TagPlaceholder];
  if (!Array.isArray(formats)) formats = [formats];
  formats.push(ClassNamePlaceholder);
  formats.forEach(function (fmt) {
    Quill.register(fmt, true);
    fmt.tagName = EmbedPlaceholder.tagName;
    fmt.className = ClassNamePlaceholder.className;
  });
}
export { EmbedPlaceholder, TagPlaceholder, ClassNamePlaceholder, convertPlaceholderHTML };